<p-toast position="bottom-right"></p-toast>

<p-confirmDialog #cd [style]="{width: '600px'}">
  <p-footer>
    <button type="button" pButton accesskey="d" icon="pi-fw fas fa-trash-alt" class="p-button-raised p-button-danger" label="Delete" (click)="cd.accept()"></button>
    <button type="button" pButton icon="pi pi-times" class="p-button-raised p-button-outlined" label="No" (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog>

<div class="client-management-page">
  <p-toolbar>
    <div class="p-toolbar-group-left">
      <p-breadcrumb [model]="items" class="p-d-none p-d-lg-inline"></p-breadcrumb>

      <span style="padding-top:2px;">
        <button pButton type="button" 
                class="p-button-rounded p-button-text p-button-primary button-icon-bold icon-large" 
                icon="pi pi-fw pi-refresh" 
                (click)="loadCompanies()"></button>

        <!-- Display only on bigger than md screens-->
        <span class="p-d-none p-d-md-inline">
          <button pButton type="button" 
                  class="p-button p-button-text" 
                  label="Add Client" 
                  icon="pi-fw fas fa-plus-circle"
                  (click)="addCompany()"></button>

          <button pButton type="button" 
                  class="p-button p-button-text" 
                  [disabled]="!selectedCompany"
                  label="Delete Client" 
                  icon="pi-fw fas fa-trash"
                  (click)="deleteCompany()"></button>  

          <button pButton type="button" 
                  class="p-button p-button-text" 
                  [disabled]="!selectedCompany"
                  label="Add Client Representative" 
                  icon="pi-fw fas fa-user-plus"
                  (click)="addCompanyRep()"></button>

          <button pButton type="button" 
                  class="p-button p-button-text" 
                  [disabled]="!selectedRep || !selectedCompany"
                  label="Delete Client Representative" 
                  icon="pi-fw fas fa-user-minus"
                  (click)="deleteCompanyRep()"></button>  
        </span>

        <!-- Display only on smaller than md screens-->
        <span class="p-d-md-none">
          <button pButton type="button" 
                  class="p-button-rounded p-button-success"
                  icon="pi-fw fas fa-plus-circle"
                  (click)="addCompany()"></button>

          <button pButton type="button" 
                  class="p-button-rounded p-button-danger"
                  [disabled]="!selectedCompany"
                  icon="pi-fw fas fa-trash"
                  (click)="deleteCompany()"></button>  

          <button pButton type="button" 
                  class="p-button-rounded p-button-success"
                  [disabled]="!selectedCompany"
                  icon="pi-fw fas fa-user-plus"
                  (click)="addCompanyRep()"></button>

          <button pButton type="button" 
                  class="p-button-rounded p-button-danger"
                  [disabled]="!selectedRep || !selectedCompany"
                  icon="pi-fw fas fa-user-minus"
                  (click)="deleteCompanyRep()"></button>  
        </span>
      </span>
    </div>

    <div class="p-toolbar-group-right">
      <!-- <i class="pi-fw fas fa-user-tag p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon" pBadge 
        severity="danger"
        pTooltip="Total Number of Roles: {{roles.length}}"
        value="{{roles.length}}"></i>

      <i class="pi-fw fas fa-users p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon" pBadge 
        severity="danger"
        pTooltip="Total Number of Users: {{roleUsers.length}}"
        value="{{roleUsers.length}}"></i>
  -->
    </div>
  </p-toolbar>

  <p-splitter class="client-splitter" styleClass="client-splitter-root" [layout]="smallScreen ? 'vertical' : 'horizontal'" [panelSizes]="[40,60]" [gutterSize]="8">
    <ng-template pTemplate>
      <div style="height: 100%; width:100%">
        <ag-grid-angular
            *ngIf="companies.length > 0"
            style="width: 100%; height:100%;"
            class="ag-theme-alpine"
            [rowSelection]="{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }"
            [gridOptions]="companyOptions"
            [context]="companyContext"
            [rowData]="companies"
            [columnDefs]="companyGridHeaders"
            [enterNavigatesVertically]="true"  
            [enterNavigatesVerticallyAfterEdit]="true"
            (gridReady)="onCompanyGridReady($event)"
            (rowClicked)="onCompanyRowClicked($event)"
            (cellKeyDown)="onCompanyCellKeyDown($event)"
            >
        </ag-grid-angular>
      </div>
    </ng-template>

    <ng-template pTemplate>
      <div style="height: 100%; width:100%">
        <ag-grid-angular
            style="width: 100%; height:100%;"
            class="ag-theme-alpine"
            [rowSelection]="{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }"
            [gridOptions]="repOptions"
            [context]="repContext"
            [rowData]="companyReps"
            [columnDefs]="repGridHeaders"
            [enterNavigatesVertically]="true"  
            [enterNavigatesVerticallyAfterEdit]="true"
            (gridReady)="onRepGridReady($event)"
            (rowClicked)="onRepRowClicked($event)"
            (cellKeyDown)="onRepCellKeyDown($event)"
            >
        </ag-grid-angular>
      </div>

    </ng-template>
  </p-splitter>
</div>

